import React from 'react';
import PropTypes from 'prop-types';
import { ElementSelector } from '@bingads-webui-campaign-react/element-selector';
import { withSiteMap, withToolsSiteMap, processorSet, withImportSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';

import { DefaultSubPageMenuLoader } from './default-sub-page-menu-loader';
import { ExperimentSubPageMenuLoader } from './experiment-sub-page-menu-loader';
import { HotelCenterSubPageMenuLoader } from './hotel-center-sub-page-menu-loader';
import { HotelCenterV2SubPageMenuLoader } from './hotel-center-v2-sub-page-menu-loader';
import { MmcStoreSubPageMenuLoader } from './mmc-sub-page-menu-loader';
import { RecommendationSubPageMenuLoader } from './recommendation-sub-page-menu-loader';
import { UetTagSubPageMenu } from './uet-tag-sub-page-menu';
import { BudgetCenterSubPageMenuLoader } from './budget-center-sub-page-menu-loader';

const BusinessDataSubPageMenuLoader = withToolsSiteMap(
  DefaultSubPageMenuLoader,
  processorSet.all,
  'business-data/business-data/*'
);

const ImportCenterSubPageMenuLoader = withImportSiteMap(
  DefaultSubPageMenuLoader,
  processorSet.all,
  'import-center/import-center/*'
);

const AutomatedRuleSubPageMenuLoader = withToolsSiteMap(DefaultSubPageMenuLoader, processorSet.all, 'rules');
const BulkEditSubPageMenuLoader = withToolsSiteMap(DefaultSubPageMenuLoader, processorSet.all, 'bulk-edits');
const ScriptsSubPageMenuLoader = withToolsSiteMap(DefaultSubPageMenuLoader, processorSet.all, 'scripts');
const BulkUploadsSubPageMenuLoader = withToolsSiteMap(DefaultSubPageMenuLoader, processorSet.all, 'bulk-uploads');
const OfflineConversionsSubPageMenuLoader = withToolsSiteMap(DefaultSubPageMenuLoader, processorSet.all, 'offline-conversions');
const UetTagSubPageMenuLoader = withToolsSiteMap(UetTagSubPageMenu, processorSet.all, 'uet-tag');

const CampaignSubPageMenuLoader = withSiteMap(DefaultSubPageMenuLoader, processorSet.all);

const SubpageMenuContainerInternal = React.memo((props) => {
  const isNavigationRefreshBudgetCenterOn = isNavigationRefreshOn(props.permissions) && props.permissions.dynamic.NavigationRefreshBudgetCenter;
  return (
    <ElementSelector fallback={(null)}>
      {isNavigationRefreshBudgetCenterOn && <BudgetCenterSubPageMenuLoader {...props} />}
      <RecommendationSubPageMenuLoader {...props} />
      <BusinessDataSubPageMenuLoader {...props} />
      <ImportCenterSubPageMenuLoader {...props} />
      <ExperimentSubPageMenuLoader {...props} />
      <AutomatedRuleSubPageMenuLoader {...props} />
      <BulkEditSubPageMenuLoader {...props} />
      <ScriptsSubPageMenuLoader {...props} />
      <BulkUploadsSubPageMenuLoader {...props} />
      <HotelCenterSubPageMenuLoader {...props} />
      <HotelCenterV2SubPageMenuLoader {...props} />
      <MmcStoreSubPageMenuLoader {...props} />
      <UetTagSubPageMenuLoader {...props} />
      <CampaignSubPageMenuLoader {...props} />
      <OfflineConversionsSubPageMenuLoader {...props} />
    </ElementSelector>
  );
});

SubpageMenuContainerInternal.propTypes = {
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
      NavigationRefreshBudgetCenter: PropTypes.bool,
    }),
  }).isRequired,
};

export const SubpageMenuContainer = withPermissions(SubpageMenuContainerInternal);
